import React, { useContext, useEffect, useState } from 'react';
import { Fade } from "react-awesome-reveal";
import Tilt from 'react-parallax-tilt';
import { Container, Row, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';
import ProjectImg from '../Image/ProjectImg';

const Projects = () => {
  const { projects } = useContext(PortfolioContext);
  const [directionText, setDirectionText] = useState('');
  const [directionImg, setDirectionImg] = useState('');

  useEffect(() => {
    if (window.innerWidth > 769) {
      setDirectionText('left');
      setDirectionImg('right');
    } else {
      setDirectionText('up');
      setDirectionImg('up');
    }
  }, []);

  return (
    <section id="projects">
      <Container>
        <div className="project-wrapper">
          <Title title="Projects" />
          {projects.map(project => {
            const { id, title, info, info2, url, repo, img } = project;
            const primaryLink = repo || url;
            const imageAlt = `${title} - Project screenshot or preview`;

            return (
              <article 
                key={id} 
                itemScope 
                itemType="https://schema.org/CreativeWork"
                className="project-item"
              >
              <Row>
                <Col lg={4} sm={12}>
                  <Fade
                    triggerOnce
                    direction={directionText}
                    duration={1000}
                    delay={500}
                  >
                    <div className="project-wrapper__text">
                      <h3 className="project-wrapper__text-title">{title || 'Project Title'}</h3>
                      <div>
                        <p>
                          {info ||
                            'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi neque, ipsa animi maiores repellendu distinctioaperiam earum dolor voluptatum consequatur blanditiis inventore debitis fuga numquam voluptate architecto itaque molestiae.'}
                        </p>
                        <p className="mb-4">{info2 || ''}</p>
                      </div>
                      {url && (
                          <a
                            target="_blank"
                            rel="noopener external"
                            className="cta-btn cta-btn--hero"
                            href={url || '#!'}
                            title={`View source code for ${title} on GitHub`}
                            aria-label={`View source code for ${title} on GitHub`}
                            itemProp="codeRepository"
                          >
                            Source Code
                          </a>
                        )}
                       {repo && (
                        <a
                          target="_blank"
                          rel="noopener external"
                          className="cta-btn cta-btn--hero"
                          href={repo}
                          title={`View live ${title} project`}
                          aria-label={`View live ${title} project`}
                          itemProp="url"
                        >
                          See Live
                        </a>
                      )}
                    </div>
                  </Fade>
                </Col>
                <Col lg={8} sm={12}>
                  <Fade
                    triggerOnce
                    direction={directionImg}
                    duration={1000}
                    delay={1000}
                  >
                    <div className="project-wrapper__image">
                      <a
                        href={primaryLink}
                        target="_blank"
                        aria-label={`View ${title} project - ${info ? info.substring(0, 60) : 'project details'}`}
                        rel="noopener external"
                        title={`View ${title} project`}
                        itemProp="url"
                        >
                        <Tilt
                        tiltMaxAngleX={8}
                        tiltMaxAngleY={8}
                        perspective={1000}
                        scale={1}
                        speed={300}
                        >
                          <div data-tilt className="thumbnail rounded">
                            <ProjectImg alt={imageAlt} filename={img} />
                          </div>
                        </Tilt>
                      </a>
                    </div>
                  </Fade>
                </Col>
              </Row>
            </article>
            );
          })}
        </div>
      </Container>
       {/* Structured Data (JSON-LD) for Projects Portfolio */}
       <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Software Engineering Projects by Nick Jeske",
          "description": "A collection of software engineering projects including Android apps, web applications, and full-stack solutions",
          "itemListElement": projects.map((project, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "SoftwareApplication",
              "name": project.title,
              "description": project.info || project.info2,
              "url": project.repo || project.url,
              "applicationCategory": "SoftwareApplication",
              "operatingSystem": project.title.includes("Android") ? "Android" : "Web",
            }
          }))
        })}
      </script>
    </section>
  );
};

export default Projects;
